import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React, { createContext, useCallback, useMemo, useState } from "react";

type DialogConfirmationProvidesProps = {
  children: React.ReactNode;
};

type DialogConfirmationOptions = {
  disabled?: boolean;
  onConfirmate?: () => void;
  onCancel?: () => void;
};

export type DialogConfirmationContextData = {
  open: boolean;
  show: (
    title: string,
    message: string,
    options?: DialogConfirmationOptions
  ) => void;
  close: () => void;
};

export const DialogConfirmationContext =
  createContext<DialogConfirmationContextData>(
    {} as DialogConfirmationContextData
  );

export function DialogConfirmationProvider({
  children,
}: DialogConfirmationProvidesProps) {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [options, setOptions] = useState<DialogConfirmationOptions>();
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");

  const show = useCallback(
    async (
      title: string,
      message: string,
      options?: DialogConfirmationOptions
    ) => {
      if (options) {
        setOptions(options);
      }
      setMessage(message);
      setTitle(title);
      setIsVisible(true);
    },
    []
  );

  const close = useCallback(() => {
    setIsVisible(false);
  }, []);

  const handleCancel = useCallback(() => {
    close();
    options?.onCancel();
  }, [options, close]);

  const toastContextData = useMemo(() => {
    return {
      show,
      close,
      open: isVisible,
    };
  }, [isVisible, close, show]);

  return (
    <DialogConfirmationContext.Provider value={toastContextData}>
      {children}
      <Dialog
        open={isVisible}
        onClose={close}
        aria-labelledby="alert-dialog-confirmation"
        aria-describedby="alert-dialog-description-confirmation"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button disabled={options?.disabled} onClick={handleCancel}>
            Cancelar
          </Button>
          <Button
            disabled={options?.disabled}
            onClick={options?.onConfirmate}
            variant="contained"
            autoFocus
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </DialogConfirmationContext.Provider>
  );
}
